import { makeAutoObservable } from "mobx";
import agent from "../api/agent";
import { TextType } from "../helpers/zwibblerHelper";
import { IZwibblerDrawing } from "../models/content";
import {
  IZwibblerBrushConfig,
  IZwibblerSize,
  IZwibblerStyle,
  IZwibblerToolConfig,
} from "../models/zwibbler";
import { RootStore } from "./rootStore";
import { toast } from "react-toastify";
import { async } from "rxjs";
import { IZoomPortionStyle } from "../models/zoomPortion";
import GenericBrowsePageResizeHelper from "../../components/common/GenericBrowsePageResizeHelper";
let Zwibbler = window["Zwibbler"];
const defaultLayerName = "default";
const laserLayerName = "laserLayer";

export default class ZwibblerStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  zwibblerCtx: any = null;
  zwibblerDivStyle: IZwibblerStyle = { top: 0, left: 0, width: 0, height: 0 };
  currentOriginalImageSize: IZwibblerSize = { width: 0, height: 0 };
  currentContainer: HTMLDivElement | null = null;

  isOneButtonEnabled: boolean = false;
  isBrushEnabled: boolean = false;
  isLaserEnabled: boolean = false;
  isPenEnabled: boolean = false;
  isCircleEnabled: boolean = false;
  isTriangleEnabled: boolean = false;
  isDoubleArrowEnabled: boolean = false;
  isArrowEnabled: boolean = false;
  isLineEnabled: boolean = false;
  isRectangleEnabled: boolean = false;
  isTextEnabled: boolean = false;
  isPickEnabled: boolean = false;
  isZoomed: boolean = false;
  zwibblerPng: any;
  brushConfig: IZwibblerBrushConfig = {
    color: "#ff0000",
    opacity: 0.6,
    lineWidth: 10,
    laserMode: true,
  };
  toolConfig: IZwibblerToolConfig = {
    color: "red",
    lineWidth: 10,
    font: "Times New Roman",
    style: 0,
    size: 8,
  };
  zwibblerSharedCtx: any = null;
  zwibblerSharedDivStyle: IZwibblerStyle = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  };
  currentSharedOriginalImageSize: IZwibblerSize = { width: 0, height: 0 };
  currentSharedContainer: HTMLDivElement | null = null;
  sharedDrawingData: string = "";
  lastSavedDrawing: string = "";
  currentZwibblerFileId: number = 0;

  zoomPortionDivStyle: IZoomPortionStyle = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    position: { x: 0, y: 0 },
  };

  originalzoomPortionDivStyle: IZoomPortionStyle = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    position: { x: 0, y: 0 },
  };

  zoomPortionPrev: IZoomPortionStyle = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    position: { x: 0, y: 0 },
  };
  zwibblerDivStylePrev: IZwibblerStyle = {
    top: 0,
    left: 0,
    width: 0,
    height: 0,
  };

  //TODO: ora utilizzato solo su schermi di sala, verificare se riutilizzabile su SignalR ecc ecc
  get CurrentZwibblerDrawing() {
    let drawing = "";
    try {
      if (this.zwibblerCtx) {
        drawing = this.zwibblerCtx.copy(true, this.zwibblerCtx.getAllNodes());
      }
    } catch (error) {}
    return drawing;
  }

  saveZwibbler = () => {
    this.zwibblerPng = this.zwibblerCtx.save("png");
  };

  setBrushConfigColor = (color: string) => {
    this.brushConfig.color = color;
    this.toolConfig.color = color;
    this.zwibblerCtx.setColour(color, true);
    if (this.isBrushEnabled) {
      this.zwibblerCtx.setOpacity(this.brushConfig.opacity, true);
    }
  };

  setBrushConfigLine = (lineWidth: number) => {
    this.brushConfig.lineWidth = lineWidth;
    this.toolConfig.lineWidth = lineWidth;
    this.zwibblerCtx.setConfig("defaultLineWidth", lineWidth);
    this.zwibblerCtx.setConfig("defaultBrushWidth", lineWidth);
  };

  setBrushConfigOpacity = (opacity: number) => {
    this.brushConfig.opacity = opacity;
  };

  setisZoomed = (state: boolean) => {
    this.isZoomed = state;
  };

  setZoomPortionDiv = (
    top: number,
    left: number,
    width: number,
    height: number,
    positionx: number,
    positiony: number
  ) => {
    this.zoomPortionDivStyle = {
      top: top,
      left: left,
      width: width,
      height: height,
      position: {
        x: positionx,
        y: positiony,
      },
    };
  };

  setZoomPortionPrec = () => {
    this.zoomPortionPrev = this.zoomPortionDivStyle;
  };

  setZwibblerPrec = () => {
    this.zwibblerDivStylePrev = this.zwibblerDivStyle;
  };


  
  calculateZoomPortionToDrag =  ( top: number, left: number, width: number, height: number, positionX: number , positionY : number) => {
    try {
      // serve per il bug del drag quando va fuori range
        var zw=  this.rootStore.zwibblerStore.zwibblerDivStyle;
        if (this.rootStore.zwibblerStore.zwibblerCtx && this.rootStore.zwibblerStore.currentContainer){
            const containerWidth = this.rootStore.zwibblerStore.currentContainer.clientWidth;
            const containerHeight = this.rootStore.zwibblerStore.currentContainer.clientHeight;
            const ratio = containerWidth / containerHeight;
            var ratioImg =
              this.rootStore.zwibblerStore.currentOriginalImageSize.width /
              this.rootStore.zwibblerStore.currentOriginalImageSize.height;
            if (ratioImg >= ratio) {
               
               return {width : width , height: height, positionX:positionX, positionY: positionY }
              
            }else{
                  // calcolo max
                    var max_x_Position_zwibbler= zw.left + zw.width;
                     var max_x_Position_zoomPortion=  positionX+ width;
                      if(max_x_Position_zoomPortion<= max_x_Position_zwibbler){
                        // console.log("--------ok-----------");
                        return {width : width , height: height, positionX:positionX, positionY: positionY }
                      }else{
                         width= max_x_Position_zoomPortion-max_x_Position_zwibbler;
                        //  console.log("--------ERRORE-----------");
                         
                          let newHeight = 0;
                          let newWidth = 0;
                  
                          if (ratioImg >= ratio) {
                            newHeight = Math.ceil(containerWidth / ratioImg);
                            newWidth = containerWidth;
                          } else {
                            newHeight = containerHeight;
                            newWidth = Math.ceil(containerHeight * ratioImg);
                          }
                      return {width : Math.ceil(newWidth / 3) , height: Math.ceil(newHeight / 3), positionX: zw.left, positionY: zw.top}
                       }       
                  }
              }
          } catch (error) {
        console.log(error);
     
      }
    };
  

  // METODI PER IL PROPRIO CONTEXT
  createZwibblerContext = async (zwibblerTagId: string, fileId: number) => {
    try {
      // this.rootStore.playerStore.isZoomPortionEnabled= false;
      const tag = document.getElementById(zwibblerTagId);
      if (tag) {
        this.currentZwibblerFileId = fileId;
        this.zwibblerCtx = Zwibbler.create(tag, {
          showPropertyPanel: false,
          background: "clear",
          showColourPanel: false,
          showToolbar: false,
          readOnly: true,
          scrollbars: false,
          defaultZoom: "page",
          allowZoom: false,
          multilineText: true,
          useTouch: true,
          autoPickTool: false,
          snap: 4,
          allowSelectBox: false,
          fonts: ["Arial", "Times New Roman", "Courier New"],
          //per aggiungere altri font aggiungerli come css e poi aggiungerli qui
        });
        this.enableButtonAfterSwipe();

        // PRENDERE IL DISEGNO ESISTENTE DALL'API
        // const prevDrawing = await agent.Content.loadZwibblerDrawing(fileId);
        // this.loadZwibblerDrawing(prevDrawing);
        // this.rootStore.tenantStore.sendSharedZwibblerDrawing(prevDrawing.data);
        // this.updateSharedZwibblerDrawing();
        await this.loadExistingDrawing(fileId);

        // AGGIUNGO GLI HANDLER PER GLI EVENTI CHE MI INTERESSANO
        let ctxCopy = this.zwibblerCtx;
        let storeCopy = this.rootStore;

        //NODES-ADDED
        this.zwibblerCtx.on("nodes-added", (nodes: number[]) => {
          this.manageLaserLayer();
          this.saveZwibblerDrawings(fileId);
        });

        //NODES-REMOVED
        this.zwibblerCtx.on("nodes-removed", (nodes: number[]) => {
          this.saveZwibblerDrawings(fileId);
        });

        //NODES-CHANGED
        //non capta portaAvanti/portaDietro
        this.zwibblerCtx.on("nodes-changed", (nodes: number[]) => {
          this.saveZwibblerDrawings(fileId);
        });

        //SELECTED-NODES
        //non capta cambio colore, ma capta porta avanti/portaDietro
        this.zwibblerCtx.on("selected-nodes", (nodes: number[]) => {
          this.saveZwibblerDrawings(fileId);
        });

        //Dopo aver finito di editare il testo impostiamo il Pick per permettere di nuovo il funzionamento del testo
        this.zwibblerCtx.on("edit-text-hidden", () => {
          this.ZwibblerUsePickTool();
        });

        this.zwibblerCtx.on("resource-loaded", () => {
          this.ZwibblerUsePickTool();
        });

        //DOCUMENT-CHANGED
        this.zwibblerCtx.on("document-changed", function (info: any) {
          if (ctxCopy.dirty()) {
            try {
              const draw = ctxCopy.copy(true, ctxCopy.getAllNodes());
              //condivisione Signal-R
              storeCopy.tenantStore.sendSharedZwibblerDrawing(draw);
              //condivisione schermi di sala
              storeCopy.tenantStore.ImageWidgetZwibblerEvent();
            } catch (error) {
              console.log(error);
            }
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  updateSharedZwibblerDrawing = () => {
    if (this.zwibblerCtx) {
      const draw = this.zwibblerCtx.copy(true, this.zwibblerCtx.getAllNodes());
      this.rootStore.tenantStore.sendSharedZwibblerDrawing(draw);
    }
  };

  destroyZwibblerContext = () => {
    try {
      if (this.zwibblerCtx) this.zwibblerCtx.destroy();
    } catch (error) {
      console.log(error);
    }
  };

  enableButtonAfterSwipe = () => {
    if (this.isBrushEnabled) this.ZwibblerUseBrushTool();
    if (this.isLaserEnabled) this.ZwibblerUseLaserTool();
    if (this.isPenEnabled) this.ZwibblerUsePenTool();
    if (this.isCircleEnabled) this.ZwibblerUseCircleTool();
    if (this.isTriangleEnabled) this.ZwibblerUseTriangleTool();
    if (this.isRectangleEnabled) this.ZwibblerUseRectangleTool();
    if (this.isPickEnabled) this.ZwibblerUsePickTool();
    if (this.isArrowEnabled) this.ZwibblerUseArrowTool();
    if (this.isDoubleArrowEnabled) this.ZwibblerUseDoubleArrowTool();
    if (this.isLineEnabled) this.ZwibblerUseLineTool();
  };

  disableReadOnly = () => {
    this.zwibblerCtx.setConfig("readOnly", false);
  };

  disableButton = () => {
    this.isOneButtonEnabled = false;
  };

  resetButton = () => {
    this.zwibblerCtx.setColour(this.brushConfig.color, true);
    this.zwibblerCtx.setActiveLayer(defaultLayerName);
    this.isBrushEnabled = false;
    this.isCircleEnabled = false;
    this.isLineEnabled = false;
    this.isPenEnabled = false;
    this.isRectangleEnabled = false;
    this.isTextEnabled = false;
    this.isDoubleArrowEnabled = false;
    this.isArrowEnabled = false;
    this.isTriangleEnabled = false;
    this.isPickEnabled = false;
    this.isLaserEnabled = false;
  };

  ZwibblerUseBrushTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isBrushEnabled = true;
        this.zwibblerCtx.setOpacity(this.brushConfig.opacity, true);
        this.zwibblerCtx.useBrushTool();
        this.zwibblerCtx.setConfig(
          "defaultBrushWidth",
          this.brushConfig.lineWidth
        );
      } else throw new Error("useBrushTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseLaserTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.zwibblerCtx.setActiveLayer(laserLayerName);
        this.isLaserEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useBrushTool();
        this.zwibblerCtx.setConfig(
          "defaultBrushWidth",
          this.brushConfig.lineWidth
        );
      } else throw new Error("useBrushTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUsePenTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isPenEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useBrushTool();
        this.zwibblerCtx.setConfig(
          "defaultBrushWidth",
          this.brushConfig.lineWidth
        );
      } else throw new Error("usePenTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseCircleTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isCircleEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useCircleTool({
          lineWidth: this.brushConfig.lineWidth,
          strokeStyle: "black",
        });
      } else throw new Error("useCircleTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseRectangleTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isRectangleEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useRectangleTool({
          lineWidth: this.brushConfig.lineWidth,
          strokeStyle: "black",
        });
      } else
        throw new Error("useRectangleTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseTriangleTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isTriangleEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.usePolygonTool(3, 0, 1.0, {
          lineWidth: this.brushConfig.lineWidth,
          strokeStyle: "black",
        });
      } else
        throw new Error("useTriangleTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseLineTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isLineEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useLineTool();
        this.zwibblerCtx.setConfig(
          "defaultLineWidth",
          this.brushConfig.lineWidth
        );
      } else throw new Error("useLineTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseArrowTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isArrowEnabled = true;
        this.zwibblerCtx.setColour(this.brushConfig.color);
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useArrowTool();
        this.zwibblerCtx.setConfig(
          "defaultLineWidth",
          this.brushConfig.lineWidth
        );
      } else throw new Error("useArrowTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseDoubleArrowTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isDoubleArrowEnabled = true;
        this.zwibblerCtx.setOpacity(1, true);
        this.zwibblerCtx.useArrowTool({ doubleArrow: true });
        this.zwibblerCtx.setConfig(
          "defaultLineWidth",
          this.brushConfig.lineWidth
        );
      } else
        throw new Error("useDoubleArrowTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseTextTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isTextEnabled = true;
        this.zwibblerCtx.useTextTool();
      } else throw new Error("useTextTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerSetTextDimension = (size: number) => {
    this.toolConfig.size = size;
    var nodiSelezionati = this.zwibblerCtx.getSelectedNodes();
    this.zwibblerCtx.setNodeProperty(nodiSelezionati, "fontSize", size);
    this.zwibblerCtx.setConfig("defaultFontSize", size);
  };

  ZwibblerSetTextFont = (font: string) => {
    this.toolConfig.font = font;
    var nodiSelezionati = this.zwibblerCtx.getSelectedNodes();
    this.zwibblerCtx.setNodeProperty(nodiSelezionati, "fontName", font);
    this.zwibblerCtx.setConfig("defaultFont", font);
  };

  ZwibblerSetLineDashes = (dashes: string) => {
    this.zwibblerCtx.setConfig("dashes", "5,2");
  };

  ZwibblerSetTextType = (type: string) => {
    switch (type) {
      case TextType.Normal.toString():
        this.toolConfig.style = 0;
        this.zwibblerCtx.setConfig("defaultBold", false);
        this.zwibblerCtx.setConfig("defaultItalic", false);
        break;
      case TextType.Bold.toString():
        this.toolConfig.style = 1;
        this.zwibblerCtx.setConfig("defaultBold", true);
        this.zwibblerCtx.setConfig("italic", false);
        break;
      case TextType.Italic.toString():
        this.toolConfig.style = 2;
        this.zwibblerCtx.setConfig("italic", true);
        this.zwibblerCtx.setConfig("defaultBold", false);
        break;
    }
  };

  ZwibblerUseImageTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.isOneButtonEnabled = true;
        this.zwibblerCtx.insertImage();
      } else throw new Error("useImage - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseCutTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.cut();
      } else throw new Error("useCut - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseDeleteAll = () => {
    try {
      if (this.zwibblerCtx) {
        this.ZwibblerUsePickTool();
        this.zwibblerCtx.deletePage();
      } else throw new Error("useCut - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseCopyTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.copy();
      } else throw new Error("useCopy - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUsePaste = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.paste();
      } else throw new Error("usePaste - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseUndo = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.undo();
      } else throw new Error("useUndo - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseRedo = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.redo();
      } else throw new Error("useUndo - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseMoveFront = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.bringToFront();
      } else throw new Error("useMoveFront - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUseMoveBack = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.sendToBack();
      } else throw new Error("useMoveBack - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerUsePickTool = () => {
    try {
      if (this.zwibblerCtx) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.resetButton();
        this.isOneButtonEnabled = true;
        this.isPickEnabled = true;
        this.zwibblerCtx.usePickTool();
      } else throw new Error("usePickTool - Zwibbler context doesn't exist");
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerEnableReadOnlyMode = () => {
    try {
      if (this.zwibblerCtx) {
        this.resetButton();
        this.disableButton();
        this.ZwibblerOverlayResize();
        this.updateSharedZwibblerDrawing();
        this.rootStore.tenantStore.ImageWidgetZwibblerEvent();
        this.zwibblerCtx.setConfig("readOnly", true);
        this.isBrushEnabled = false;
      } else
        throw new Error(
          "ZwibblerEnableReadOnlyMode - Zwibbler context doesn't exist"
        );
    } catch (error) {
      console.log(error);
    }
  };

  ZwibblerChangeBrushConfig = () => {
    try {
      if (this.zwibblerCtx) {
        this.brushConfig.lineWidth += 10;
        this.updateZwibblerBrushConfig();
      } else
        throw new Error(
          "ZwibblerChangeBrushConfig - Zwibbler context doesn't exist"
        );
    } catch (error) {
      console.log(error);
    }
  };

  setOriginalImageSize = (width: number, height: number) => {
    this.currentOriginalImageSize = { width: width, height: height };
  };

  setCurrentContainer = (tag: HTMLDivElement | null) => {
    this.currentContainer = tag;
  };

  initializeZwibblerContainer = (
    width: number,
    height: number,
    tag: HTMLDivElement | null
  ) => {
    this.setOriginalImageSize(width, height);
    this.setCurrentContainer(tag);
  };

zwiblerOverlayResizeZoomPortion = () => {
  setTimeout(() => {
    this.rootStore.zwibblerStore.ZwibblerOverlayResize();
  }, 100);
}


  ZwibblerOverlayResize = () => {
    try {
      //  console.log("-----------ZwibblerOverlayResize---------------");

      if (this.zwibblerCtx && this.currentContainer) {
        const containerWidth = this.currentContainer.clientWidth;
        const containerHeight = this.currentContainer.clientHeight;

        // COPIATURA ZWIBBLER PRECEDENTE IMPORTANTE PER RECUPEARE LO STATO PRECEDENTE
        this.zwibblerDivStylePrev = this.zwibblerDivStyle;

        const ratio = containerWidth / containerHeight;
        var ratioImg =
          this.currentOriginalImageSize.width /
          this.currentOriginalImageSize.height;
        let newHeight = 0;
        let newWidth = 0;
        if (ratioImg >= ratio) {
           
          newHeight = Math.ceil(containerWidth / ratioImg);
          newWidth = containerWidth;
          this.zwibblerDivStyle = {
            top: (containerHeight - newHeight) / 2,
            left: 0,
            width: newWidth,
            height: newHeight,
          };
          // console.log("x " +  this.zwibblerDivStyle.left);
          // console.log("y " +  this.zwibblerDivStyle.top);
        } else {
          //  console.log("zw.left=x  zw.top=0");
          newHeight = containerHeight;
          newWidth = Math.ceil(containerHeight * ratioImg);
          this.zwibblerDivStyle = {
            top: 0,
            left: (containerWidth - newWidth) / 2,
            width: newWidth,
            height: newHeight,
          };
          // console.log("x " +  this.zwibblerDivStyle.left);
          // console.log("y " +  this.zwibblerDivStyle.top);
        }

        if (this.rootStore.playerStore.isZoomPortionEnabled)
          this.resizeZoomPortion();

        const overlayDPIfactor = 800;
        this.zwibblerCtx.resize();
        this.zwibblerCtx.setPaperSize(
          ratioImg * overlayDPIfactor,
          overlayDPIfactor
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  resizeHandlerZwibbler=()=> {
   setTimeout(() => {
      this.ZwibblerOverlayResize();
    }, 100);
  }

  initializeZoomPortion = () => {
    try {
      // console.log("---------------initializeZoomPortion---------------------");
      //  toast.info("ZwibblerOverlayResize");
      if (this.zwibblerCtx && this.currentContainer) {
        const containerWidth = this.currentContainer.clientWidth;
        const containerHeight = this.currentContainer.clientHeight;
        // toast.error("container: " + containerWidth + "x" + containerHeight);
      const ratio = containerWidth / containerHeight;
        var ratioImg =
          this.currentOriginalImageSize.width /
          this.currentOriginalImageSize.height;
        let newHeight = 0;
        let newWidth = 0;

        if (ratioImg >= ratio) {
          newHeight = Math.ceil(containerWidth / ratioImg);
          newWidth = containerWidth;
        } else {
          newHeight = containerHeight;
          newWidth = Math.ceil(containerHeight * ratioImg);
        }
        this.zoomPortionDivStyle = {
          top: this.zwibblerDivStyle.top,
          left: this.zwibblerDivStyle.left,
          width: Math.ceil(newWidth / 3),
          height: Math.ceil(newHeight / 3),
          position: {
            x: this.zwibblerDivStyle.left,
            y: this.zwibblerDivStyle.top,
          },
        };

        this.originalzoomPortionDivStyle = this.zoomPortionDivStyle;
        this.setZoomPortionPrec();
      }
    } catch (error) {
      console.log(error);
    }
  };

  resizeZoomPortion = () => {
    try {
      //  console.log("---------------resizeZoomPortion---------------------");

      if (this.zwibblerCtx && this.currentContainer) {
      
        const containerWidth = this.currentContainer.clientWidth;
        const containerHeight = this.currentContainer.clientHeight;

          if (this.rootStore.playerStore.isZoomPortionEnabled) {
         
          const ratio = containerWidth / containerHeight;
          var ratioImg =
            this.currentOriginalImageSize.width /
            this.currentOriginalImageSize.height;

          let ratioWidth = 0;
          ratioWidth =
            this.zwibblerDivStylePrev.width / this.zwibblerDivStyle.width;

          // console.log("ratio2:" + ratioWidth);
          let positionX = 0;
          let positionY = 0;
          if (this.rootStore.playerStore.isZoomPortionEnabled) {
            if (ratioImg >= ratio) {
              // console.log(" zw.left=0  zw.top=Y"); // // zw.left=0  zw.top=Y
              if (this.zwibblerDivStylePrev.left == 0) {
                positionX = this.zoomPortionDivStyle.position.x;
                positionY =
                  this.zoomPortionDivStyle.position.y -
                  this.zwibblerDivStylePrev.top;
                 } else {
                positionX =
                  this.zoomPortionDivStyle.position.x -
                  this.zwibblerDivStylePrev.left;
                positionY = this.zoomPortionDivStyle.position.y;
            
              }
              this.zoomPortionDivStyle = {
                top: 0,
                left: 0,
                width: this.zoomPortionDivStyle.width / ratioWidth,
                height: this.zoomPortionDivStyle.height / ratioWidth,
                position: {
                  x: positionX / ratioWidth,

                  y: positionY / ratioWidth + this.zwibblerDivStyle.top,
                },
              };
            } else {
              // console.log(" left=x  top=0"); // zw.left=x  zw.top=0
              if (this.zwibblerDivStylePrev.left == 0) {
                positionX = this.zoomPortionDivStyle.position.x;
                positionY =
                  this.zoomPortionDivStyle.position.y -
                  this.zwibblerDivStylePrev.top;
               
              } else {
                positionX =
                  this.zoomPortionDivStyle.position.x -
                  this.zwibblerDivStylePrev.left;
                positionY = this.zoomPortionDivStyle.position.y;
              }
              this.zoomPortionDivStyle = {
                top: 0,
                left: 0,
                width: this.zoomPortionDivStyle.width / ratioWidth,
                height: this.zoomPortionDivStyle.height / ratioWidth,
                position: {
                  x: positionX / ratioWidth + this.zwibblerDivStyle.left,

                  y: positionY / ratioWidth,
                },
              };
            }
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };
  // METODI PER IL CONTEXT CONDIVISO
  createSharedZwibblerContext = async (zwibblerTagId: string) => {
    try {
      const tag = document.getElementById(zwibblerTagId);
      if (tag) {
        this.zwibblerSharedCtx = Zwibbler.create(tag, {
          showPropertyPanel: false,
          background: "clear", //clear
          showColourPanel: false,
          showToolbar: false,
          readOnly: true,
          scrollbars: false,
          defaultZoom: "page",
          allowZoom: false,
          multilineText: true,
          useTouch: true,
          autoPickTool: false,
          snap: 4,
          allowSelectBox: false,
          fonts: ["Arial", "Times New Roman", "Courier New"],
        });

        this.loadSharedZwibblerDrawing();
      }
    } catch (error) {
      console.log(error);
    }
  };

  destroySharedZwibblerContext = () => {
    try {
      if (this.zwibblerSharedCtx) this.zwibblerSharedCtx.destroy();
    } catch (error) {
      console.log(error);
    }
  };

  setSharedOriginalImageSize = (width: number, height: number) => {
    this.currentSharedOriginalImageSize = { width: width, height: height };
  };

  setSharedCurrentContainer = (tag: HTMLDivElement | null) => {
    this.currentSharedContainer = tag;
  };

  initializeSharedZwibblerContainer = (
    width: number,
    height: number,
    tag: HTMLDivElement | null
  ) => {
    this.setSharedOriginalImageSize(width, height);
    this.setSharedCurrentContainer(tag);
  };

  ZwibblerSharedOverlayResize = () => {
    try {
      if (this.zwibblerSharedCtx && this.currentSharedContainer) {
        const containerWidth = this.currentSharedContainer.clientWidth;
        const containerHeight = this.currentSharedContainer.clientHeight;
        //toast.error("container: " + containerWidth + "x" + containerHeight);

        const ratio = containerWidth / containerHeight;
        var ratioImg =
          this.currentSharedOriginalImageSize.width /
          this.currentSharedOriginalImageSize.height;
        let newHeight = 0;
        let newWidth = 0;

        //20px è il pading dello screen
        if (ratioImg >= ratio) {
          newHeight = Math.ceil(containerWidth / ratioImg);
          newWidth = containerWidth;
          this.zwibblerSharedDivStyle = {
            top: (containerHeight - newHeight) / 2,
            left: 0,
            width: newWidth,
            height: newHeight,
          };
        } else {
          newHeight = containerHeight;
          newWidth = Math.ceil(containerHeight * ratioImg);
          this.zwibblerSharedDivStyle = {
            top: 0,
            left: 0 + (containerWidth - newWidth) / 2,
            width: newWidth,
            height: newHeight,
          };
        }

        //toast.info("dimensioni zwibbler: " + newWidth + "x" + newHeight);
        const overlayDPIfactor = 800;
        this.zwibblerSharedCtx.resize();
        this.zwibblerSharedCtx.setPaperSize(
          ratioImg * overlayDPIfactor,
          overlayDPIfactor
        );
      } else {
        throw new Error(
          "ZwibblerSharedOverlayResize - Zwibbler context doesn't exist"
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  setSharedZwibblerDrawingData = (drawingData: string) => {
    this.sharedDrawingData = drawingData;
  };

  loadSharedZwibblerDrawing() {
    if (this.zwibblerSharedCtx) {
      this.zwibblerSharedCtx.newDocument();
      if (this.sharedDrawingData) {
        const isReadonly = this.zwibblerSharedCtx.getConfig("readOnly");
        if (isReadonly) {
          this.zwibblerSharedCtx.setConfig("readOnly", false);
          this.zwibblerSharedCtx.setConfig("pasteOffset", 0);
          this.zwibblerSharedCtx.paste(this.sharedDrawingData);
          this.zwibblerSharedCtx.setConfig("readOnly", true);
        } else {
          this.zwibblerSharedCtx.setConfig("pasteOffset", 0);
          this.zwibblerSharedCtx.paste(this.sharedDrawingData);
        }
        this.ZwibblerSharedOverlayResize();
      }
    }
  }

  // PRIVATE METHODS
  private saveZwibblerDrawings(fileId: number) {
    try {
      if (this.zwibblerCtx && this.zwibblerCtx.dirty() && fileId > 0) {
        const isCorrectFileId =
          fileId > 0 && fileId === this.currentZwibblerFileId;
        const draw = this.zwibblerCtx.copy(
          true,
          this.zwibblerCtx.getLayerNodes(defaultLayerName)
        );
        if (draw && draw !== this.lastSavedDrawing && isCorrectFileId) {
          this.lastSavedDrawing = draw;
          agent.Content.saveZwibblerDrawing({
            fileId: fileId,
            data: draw,
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  private loadZwibblerDrawing(drawing: IZwibblerDrawing) {
    if (this.zwibblerCtx && drawing && drawing.data) {
      const isReadonly = this.zwibblerCtx.getConfig("readOnly");
      if (isReadonly) {
        this.zwibblerCtx.setConfig("readOnly", false);
        this.zwibblerCtx.deletePage();
        this.zwibblerCtx.setConfig("pasteOffset", 0);
        this.zwibblerCtx.paste(drawing.data);
        this.zwibblerCtx.setConfig("readOnly", true);
      } else {
        this.zwibblerCtx.deletePage();
        this.zwibblerCtx.setConfig("pasteOffset", 0);
        this.zwibblerCtx.paste(drawing.data);
      }
    }
  }

  private updateZwibblerBrushConfig() {
    const isReadonly = this.zwibblerCtx.getConfig("readOnly");
    if (isReadonly) {
      this.zwibblerCtx.setConfig("readOnly", false);
      this.zwibblerCtx.setColour(this.brushConfig.color, true);
      this.zwibblerCtx.setOpacity(this.brushConfig.opacity, true);
      this.zwibblerCtx.setConfig("readOnly", true);
    } else {
      this.zwibblerCtx.setColour(this.brushConfig.color, true);
      this.zwibblerCtx.setOpacity(this.brushConfig.opacity, true);
      this.zwibblerCtx.useBrushTool({ lineWidth: this.brushConfig.lineWidth });
    }
  }

  private manageLaserLayer() {
    //se sto utilizzando l'EVIDENZIATORE cancellerò gli altri nodi ogni volta che ne aggiungerò uno
    if (this.isLaserEnabled) {
      //prendo tutti i nodi del layer LASER
      let laserNodes = this.zwibblerCtx.getLayerNodes(laserLayerName);
      //elimino l'ultimo elemento, ossia quello che ho appena disegnato
      laserNodes.pop();
      this.zwibblerCtx.deleteNode(laserNodes);
    }
    //SE DOBBIAMO ELIMINARE L'ULTIMO DISEGNO LASER QUANDO CAMBIAMO FUNZIONE
    else {
      let laserNodes = this.zwibblerCtx.getLayerNodes(laserLayerName);
      this.zwibblerCtx.deleteNode(laserNodes);
    }
  }

  private async loadExistingDrawing(fileId: number) {
    try {
      // PRENDERE IL DISEGNO ESISTENTE DALL'API
      const prevDrawing = await agent.Content.loadZwibblerDrawing(fileId);
      this.loadZwibblerDrawing(prevDrawing);
      this.rootStore.tenantStore.sendSharedZwibblerDrawing(prevDrawing.data);
      this.updateSharedZwibblerDrawing();
    } catch (error) {}
  }
}
